import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import TabChartFilter from "../components/TabChartFilter";
import {
  useGetDamagePlate,
  useGetOrderDamageAreaChart,
} from "../../../Production/OrderArchive/Hook";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import TotalChart from "../TotalChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import TitleChart from "../components/TitleChart";
import BuutonFilter from "../components/BuutonFilter";
import FilterKilscheTypeAndThicknes from "../../DashboardChart/AvrageKlischePrice/FilterKilscheTypeAndThicknes";
import moment from "moment-jalaali";
import { FilterIcon } from "lucide-react";
import FilterHandler from "../components/FilterHandler";

function DamageChart() {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  const theme = useTheme().palette.mode;

  const [activeFilterType, setActiveFilterType] = useState(1);
  const [KlischeType, setKlischeType] = useState({
    KlischeType: "00000000-0000-0000-0000-000000000000",
  });
  const [KilscheThicknes, setKilscheThicknes] = useState({
    KilscheThicknes: "00000000-0000-0000-0000-000000000000",
  });
  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };
  const currentJalaliYear = moment().locale("en").format("jYYYY");
  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState(0);

  /* ----------------------------- Initial States ----------------------------- */

  const [dataLineChart, setDataLineChart] = useState([]);
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const { mutate, data } = useGetDamagePlate();
  const { mutate: orderMutate, data: orderData } = useGetOrderDamageAreaChart();
  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : { name: "year", enum: 2 },
    );
  };
  //*total count state
  const [total, setTotal] = useState([]);
  //re-render
  useEffect(() => {
    if (activeFilterType == 1) {
      mutate({
        chartReportTiming: chartFilter.enum,
        klischeTypeId: KlischeType.KlischeType,
        klischeThicknessId: KilscheThicknes.KilscheThicknes,
        year: year.year,
        month: month.month,
      });
    } else if (activeFilterType == 2) {
      orderMutate({
        chartReportTiming: chartFilter.enum,
        klischeTypeId: KlischeType.KlischeType,
        klischeThicknessId: KilscheThicknes.KilscheThicknes,
        year: year.year,
        month: month.month,
      });
    }
  }, [chartFilter, activeFilterType, KilscheThicknes, KlischeType, year]);
  useEffect(() => {
    if (activeFilterType == 1 && data) {
      setDataLineChart(data?.data?.data.items);
      setTotal([
        {
          count: data?.data?.data?.total,
          color: "#3592FB",
          title: "مساحت",
          key: "total_1_1",
        },
      ]);
    } else if (activeFilterType == 2 && orderData) {
      setDataLineChart(orderData?.data?.data.items);
      setTotal([
        {
          count: orderData?.data?.data?.total,
          color: "#3592FB",
          title: "مساحت",
          key: "total_1_1",
        },
      ]);
    }
  }, [data, orderData]);
  const deviceType = useDeviceType();

  /* ------------------------------- resetValue ------------------------------- */
  useEffect(() => {
    setKilscheThicknes({
      KilscheThicknes: "00000000-0000-0000-0000-000000000000",
    });
    setKlischeType({ KlischeType: "00000000-0000-0000-0000-000000000000" });
  }, [activeFilterType]);

  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "damagePlateChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);

  return (
    <div>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                padding: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"پلیت"}
                type={1}
                activeFilterType={activeFilterType}
              />
              <BuutonFilter
                changeActiveFilterType={changeActiveFilterType}
                label={"سفارش"}
                type={2}
                activeFilterType={activeFilterType}
              />
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"خرابی "} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                {" "}
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                />
              </Box>{" "}
              <FilterHandler filter={filter} setFilter={setFilter} />
            </Box>
          </Box>
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  padding: "8px",
                  backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                }}
              >
                <FilterKilscheTypeAndThicknes
                  KlischeType={KlischeType}
                  setKlischeType={setKlischeType}
                  KilscheThicknes={KilscheThicknes}
                  setKilscheThicknes={setKilscheThicknes}
                  chartFilter={chartFilter}
                  year={year}
                  setYear={setYear}
                  month={month}
                  setMonth={setMonth}
                />
              </Box>
            </Fade>
          )}

          {activeFilterType === 1 && (
            <ResponsiveContainer width="100%" minHeight={"18rem"}>
              <LineChart
                width={"auto"}
                height={"17.5rem"}
                data={dataLineChart}
                margin={{
                  top: 5,
                  right: 5,
                  left: deviceType === "mobile" ? -10 : 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  fontSize={"10px"}
                  angle={0}
                  tickMargin={5}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <YAxis
                  fontSize={deviceType === "mobile" ? "11px" : "14px"}
                  tickMargin={deviceType === "mobile" ? 30 : 50}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <Tooltip
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div
                          style={{
                            background: "#fff",
                            color: "#1E6AFD",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                          }}
                        >
                          {payload.map((entry, i) => (
                            <div key={i}>
                              {entry.name} :{toPersianDigits(entry.value)}
                            </div>
                          ))}
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Line
                  type="monotone"
                  name="مساحت خرابی"
                  dataKey="value"
                  stroke="#3592FB"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
          )}

          {activeFilterType == 2 && (
            <ResponsiveContainer width="100%" minHeight={"18rem"}>
              <LineChart
                width={"auto"}
                height={"17.5rem"}
                data={dataLineChart}
                margin={{
                  top: 5,
                  right: 5,
                  left: deviceType === "mobile" ? -10 : 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  fontSize={"10px"}
                  angle={0}
                  tickMargin={5}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <YAxis
                  fontSize={deviceType === "mobile" ? "11px" : "14px"}
                  tickMargin={deviceType === "mobile" ? 30 : 50}
                  tickFormatter={(value) => toPersianDigits(value)}
                />
                <Tooltip
                  content={({ active, payload, label }) => {
                    if (active && payload && payload.length) {
                      return (
                        <div
                          style={{
                            background: "#fff",
                            color: "#1E6AFD",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                          }}
                        >
                          {payload.map((entry, i) => (
                            <div key={i}>
                              {entry.name} :{toPersianDigits(entry.value)}
                            </div>
                          ))}
                        </div>
                      );
                    }
                    return null;
                  }}
                />
                <Line
                  type="monotone"
                  name="مساحت خرابی"
                  dataKey="value"
                  stroke="#3592FB"
                  activeDot={{ r: 8 }}
                />
              </LineChart>
            </ResponsiveContainer>
          )}
          <Box display={"flex"}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              {deviceType != "mobile" && <TotalChart total={total} />}
            </Box>
          </Box>
        </>
      ): <Box
              sx={{
                flexGrow: 1,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                minWidth: 200,
              }}
            >
              <TitleChart label={"خرابی "} chartKey={chartKey} />
            </Box>}
    </div>
  );
}

export default DamageChart;
